import { render, staticRenderFns } from "./ProductPickerWithIcon.vue?vue&type=template&id=6bd99172&"
import script from "./ProductPickerWithIcon.vue?vue&type=script&lang=js&"
export * from "./ProductPickerWithIcon.vue?vue&type=script&lang=js&"
import style0 from "./ProductPickerWithIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports